export default __webpack_public_path__ + "static/poweredby-4-2688ffb48933bdcf298ff867fe6c26b5.mp4";